export default function Table({ children, minWidth = '800px' }) {
    return (
        <div className="overflow-x-auto -mx-px" style={{ WebkitOverflowScrolling: 'touch' }}>
            <table className="w-full text-sm" style={{ minWidth }}>
                {children}
            </table>
        </div>
    );
}

export function Th({ children, className = '' }) {
    return (
        <th className={`text-left px-3 sm:px-4 py-3 font-semibold text-slate-600 bg-slate-50 border-b border-slate-200 whitespace-nowrap text-xs sm:text-sm ${className}`}>
            {children}
        </th>
    );
}

export function Td({ children, className = '' }) {
    return (
        <td className={`px-3 sm:px-4 py-3 text-sm ${className}`}>
            {children}
        </td>
    );
}

export function Tr({ children, className = '', onClick, ...props }) {
    return (
        <tr className={`hover:bg-slate-50/50 transition-colors border-b border-slate-100 last:border-0 ${className}`} onClick={onClick} {...props}>
            {children}
        </tr>
    );
}
